import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '../../assets/styles/components/tab-header/tab-header.scss';
import { getSafe } from '@/helpers/global';
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import LightRefreshIcon from '@/assets/images/icons/light/icon_refresh.png';
import CheckedIcon from '@/assets/images/icons/icon_select_hit.png';
import UnCheckIcon from '@/assets/images/icons/icon_select_normal.png';
// import { ORDER_FILTER_STATUS, TRANSACTION_TYPE } from '@/constants/filter-type';
import { ORDER_FILTER_STATUS, TRANSACTION_TYPE } from '@/companys/scb/constants/filter-type';
import { DATE_PICKER_TYPE } from '@/constants/app';
import DatePickerCustom from '@/components/DatePicker/DatePickerCustom';
import Dropdown from '@/components/Dropdown/Dropdown';

class TabHeader extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this)
    this.state = {
      mainTabs: [],
      subTabs: [],
      currentMainTab: {},
      currentSubTab: {},
      haveActions: false,
      selectedOrderFilterStatus: ORDER_FILTER_STATUS[0].value,
      selectedTransactionHistoryType: TRANSACTION_TYPE[0].value,
      minimumDate: {},
      fromDate: {},
      toDate: {},
    }
  }
  render() {
    const { justifyContent, alignItems, enableScroll, language, customStyle, refresh, orderFilter, dateRangePicker, orderFilterDropdown,codeInput, transactionHistoryFilter, style, marketFilter, portfolioTips, accountDropDown, accountData, browser, theme } = this.props;
    const { mainTabs, subTabs, currentMainTab, currentSubTab, haveActions } = this.state;

    return (
      <div className='tab-header-container' style={style}>
        <div className={classnames('main-tab', subTabs.length > 0 && 'main-tab-has-children', enableScroll && 'scroll-horizontal')}
          style={{ justifyContent: justifyContent, alignItems: alignItems }}>
          {mainTabs.map(tab =>
            <div key={tab.id}
              style={customStyle}
              className={classnames('main-tab-item', getSafe(() => currentMainTab.id, -1) === tab.id && 'main-tab-item-active')}
              onClick={() => this.handleChangeMainTab(tab)}
              title={getSafe(() => language[tab.title], tab.title)}>
              {getSafe(() => language[tab.title], tab.title)}
            </div>
          )}
          {portfolioTips && this.renderPortfolioTipsDropdown()}
          {haveActions && <div className='tab-header-action'>
            {dateRangePicker && this.renderDateRangePicker()}
            {orderFilter && this.renderOrderFilter()}
            {codeInput && this.renderCodeInput()}
            {orderFilterDropdown && this.renderOrderFilterDropdown()}
            {transactionHistoryFilter && this.renderHistoryFilterDropdown()}
            {accountDropDown && this.renderAccountDropdown()}
            {marketFilter && this.renderMarketDropdown()}
            {refresh &&
              <div className='action-item'>
                <img src={ (browser === 'ie' && theme==='light') ? LightRefreshIcon : RefreshIcon } alt={language.common_refresh} title={language.common_refresh} onClick={this.props.onRefresh} />
              </div>
            }
          </div>}
        </div>
        <div className='sub-tab'>
          {subTabs.map(tab =>
            <div key={tab.id}
              className={classnames('sub-tab-item', getSafe(() => currentSubTab.id, -1) === tab.id && 'sub-tab-item-active')}
              onClick={() => this.handleChangeSubTab(tab)}>
              {getSafe(() => language[tab.title], tab.title)}
            </div>
          )}
        </div>
      </div>
    )
  }

  handleSelectOrderType(key) {
    if (key) {
      this.setState({ selectedOrderFilterStatus: key.value });
      this.props.onSelectOrderFilter(key.value)
    }
  }

  inputCodePressKey(event){
    if(event.key === 'Enter'){
      this.handleInputCode(event);
    }
  }

  handleInputCode(event){
    const code = event.target.value;
    this.props.onInputCodeFilter(code)
  }

  handleSelectTransitionHistoryType(key) {
    this.setState({ selectedTransactionHistoryType: key.value });
    this.props.onSelectHistoryFilter(key.value)
  }

  setDatePickerValue(value) {
    this.setState({ fromDate: value, toDate: value })
    this.datePickerFromRef && this.datePickerFromRef.setValue(value)
    this.datePickerToRef && this.datePickerToRef.setValue(value)
  }

  getTransactionHistoryValue() {
    return this.state.selectedTransactionHistoryType
  }

  validateDateRangePicker = (isFromDate, val) => {
    if (isFromDate) {
      this.setState({ minimumDate: val, fromDate: val })
      const { toDate } = this.state;
      if (Object.keys(val).length > 0 && Object.keys(toDate).length > 0) {
        const fDate = new Date(val.year, val.month - 1, val.day);
        const tDate = new Date(toDate.year, toDate.month - 1, toDate.day);
        if (fDate.getTime() > tDate.getTime()) {
          this.datePickerToRef.setValue(val)
          this.props.onChangeDatePicker({ from: val, to: val })
        } else {
          this.props.onChangeDatePicker({ from: val, to: toDate })
        }
      }
    } else {
      this.setState({ toDate: val })
      const { fromDate } = this.state;
      if (Object.keys(val).length > 0 && Object.keys(fromDate).length > 0) {
        this.props.onChangeDatePicker({ from: fromDate, to: val })
      }
    }
  }

  renderMarketDropdown() {
    const { currentMarket, language, markets, tabs} = this.props;
    let allMarkets = JSON.parse(JSON.stringify(markets));
    let isTradePortfolio = false;
    for (let i = 0; i < tabs.length; i++) {
      if(tabs[i]['title'] === 'portfolio_title'){
        isTradePortfolio = true;
        allMarkets.push({
          label: language.market_all,
          value: ""
        })
        break;
      }
    }
    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.common_market}:</label>
          <Dropdown options={isTradePortfolio ? allMarkets : markets}
            selectedOptions={isTradePortfolio ? [allMarkets[allMarkets.length-1]] : [markets[0]]}
            onChange={(mrk) => this.props.onChangeMarket(mrk[0])}
          />
        </div>
      </div>
    )
  }

  renderPortfolioTipsDropdown() {
    const { language } = this.props;
    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <div className="margin-315">
            <span style={{color:'red'}}>{'*'}</span>
            <span className="margin-10">{getSafe(() => language.portfolio_tips)}</span>
          </div>
        </div>
      </div>
    )
  }

  renderAccountDropdown() {
    let { language, accountData, accountIndex } = this.props;
    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.common_settlement_account_no}:</label>
          {
            accountData.length > 0 ? <Dropdown options={accountData}
              selectedOptions={[accountData[accountIndex]]}
              onChange={(acc, index) => this.props.onChangeAccount(acc[0], index)}
            />
              :
              <div>{language.common_no_data}</div>
          }
        </div>
      </div>
    )
  }

  renderDateRangePicker() {
    const { language, maximumDate } = this.props;
    const { minimumDate } = this.state;
    return (
      <div className='action-item'>
        <div className="date-picker-filter-container">
          <label>{language.common_filter_enquiry_period}:</label>
          <div className="picker-item">
            <label>{language.common_from}</label>
            <DatePickerCustom
              style={{ height: 23, width: 110, marginTop: -3 }}
              type={DATE_PICKER_TYPE.SINGLE_DATE}
              innerRef={e => this.datePickerFromRef = e}
              onChange={(val) => this.validateDateRangePicker(true, val)}
              maximumDate={maximumDate} />
          </div>
          <div className="picker-item">
            <label>{language.common_to}</label>
            <DatePickerCustom
              style={{ height: 23, width: 110, marginTop: -3 }}
              type={DATE_PICKER_TYPE.SINGLE_DATE}
              innerRef={e => this.datePickerToRef = e}
              onChange={(val) => this.validateDateRangePicker(false, val)}
              minimumDate={minimumDate}
              maximumDate={maximumDate} />
          </div>
        </div>
      </div>
    )
  }

  renderOrderFilterDropdown() {
    const { language } = this.props;

    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    const defaultSelected = filterOptions.filter(item => item.value === this.state.selectedOrderFilterStatus)

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{this.state.currentMainTab.title=="order_book_title"?language.common_status:language.common_order_history_status}:</label>
          <Dropdown options={filterOptions}
            selectedOptions={defaultSelected}
            onChange={(opt) => this.handleSelectOrderType(opt[0])}
            innerRef={e => this.orderFilterDropdownRef = e}
          />
        </div>
      </div>
    )
  }

  resetOrderFilterDropdown(){
    const { language } = this.props;
    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])
    this.orderFilterDropdownRef.setValue([filterOptions[0]]);
  }

  resetCodeInput(){
    document.getElementById('instrumentID-input').value='';
  }

  renderCodeInput(){
    const {language} = this.props;
    return(
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.common_symbol}:</label>
          <input type='text'
            onBlur={this.handleInputCode.bind(this)}
            onKeyPress={this.inputCodePressKey.bind(this)}
            id='instrumentID-input'/>
        </div>
      </div>
    )
  }

  renderHistoryFilterDropdown() {
    const { language } = this.props;

    const filterOptions = TRANSACTION_TYPE.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className='action-item'>
        <div className="order-filter-dropdown-container">
          <label>{language.transaction_type}:</label>
          <Dropdown style={{ minWidth: '210px' }} options={filterOptions}
            selectedOptions={[filterOptions[0]]}
            onChange={(opt) => this.handleSelectTransitionHistoryType(opt[0])}
          />
        </div>
      </div>
    )
  }

  renderOrderFilter() {
    const { language } = this.props;
    const { selectedOrderFilterStatus } = this.state;
    return (
      <div className='action-item'>
        <div className="order-filter-container">
          {ORDER_FILTER_STATUS.map(item =>
            <div key={item.value} className='filter-item' onClick={() => this.handleSelectOrderType(item)}>
              <img src={item.value === selectedOrderFilterStatus ? CheckedIcon : UnCheckIcon} alt="checked_icon" />
              {language[item.label]}
            </div>)}
        </div>
      </div>
    )
  }

  handleChangeMainTab(mainTab) {
    const activeTab = {
      main: mainTab
    }
    this.setState({ currentMainTab: mainTab })
    if (mainTab.children && mainTab.children.length > 0) {
      const activeSubTab = mainTab.children.find(tab => tab.isActive);
      const finalActiveSubTab = activeSubTab ? activeSubTab : mainTab.children[0]
      activeTab.sub = finalActiveSubTab;
      this.setState({ currentSubTab: finalActiveSubTab, subTabs: mainTab.children })
    } else {
      this.setState({ currentSubTab: {}, subTabs: [] })
    }
    this.props.onChange(activeTab);
  }

  handleChangeSubTab(subTab) {
    const activeTab = {
      main: this.state.currentMainTab,
      sub: subTab
    }
    this.props.onChange(activeTab);
    this.setState({ currentSubTab: subTab })
  }

  initData() {
    // Check tabs is valid object format;
    const { tabs } = this.props;
    if (tabs.length > 0) {
      const defaultActiveMainTab = tabs.find(tab => tab.isActive);
      const finalActiveMainTab = defaultActiveMainTab ? defaultActiveMainTab : tabs[0];
      if (finalActiveMainTab.children && finalActiveMainTab.children.length > 0) {
        const defaultActiveSubTab = finalActiveMainTab.children.find(tab => tab.isActive);
        const finalActiveSubTab = defaultActiveSubTab ? defaultActiveSubTab : finalActiveMainTab.children[0];
        this.setState({ subTabs: finalActiveMainTab.children, currentSubTab: finalActiveSubTab })
      }
      this.setState({ mainTabs: tabs, currentMainTab: finalActiveMainTab })
    }
  }

  componentDidMount() {
    this.setState({
      selectedAccount: this.props.currentTradingAccount,
      currencyIDTradingAccounts: this.props.tradingAccounts
    }, () => {
      this.initData();
      this.setState({
        haveActions: this.props.refresh ||
          this.props.orderFilter ||
          this.props.datePicker ||
          this.props.orderFilterDropdown ||
          this.props.codeInput ||
          this.props.transactionHistoryFilter ||
          this.props.marketFilter ||
          this.props.accountDropDown
      })
    })

  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.initData();
    }
    if (JSON.stringify(prevProps.tabs) !== JSON.stringify(this.props.tabs)) {
      this.initData();
    }
  }
}

TabHeader.defaultProps = {
  innerRef: () => { },
  tabs: [],
  onChange: () => { },
  justifyContent: 'flex-start',
  alignItems: 'center',
  enableScroll: false,
  customStyle: null,
  refresh: null,
  onRefresh: () => { },
  orderFilter: null,
  orderFilterDropdown: null,
  codeInput:null,
  onSelectOrderFilter: () => { },
  dateRangePicker: null,
  maximumDate: {},
  onChangeDatePicker: () => { },
  style: {},
  marketFilter: null,
  portfolioTips:null,
  accountDropDown: null,
  onChangeMarket: () => { },
  onChangeAccount: () => { },
  accountData: []
}

export default connect(
  state => ({
    language: state.app.language,
    currentMarket: state.trade.currentMarket,
    markets: state.trade.markets,
    tradingAccounts: state.trade.tradingAccounts,
    currentTradingAccount: state.trade.currentTradingAccount,
    browser:state.app.browser,
    theme:state.app.theme
  }),
  dispatch => ({
  })
)(TabHeader)
